<template>
 <v-dialog v-model="dialogAdd" persistent max-width="500px" max-height="500px" style="overflow-y: hidden;">
  <v-card>
    <!-- v-card-title>
      <span class="headline Kanit">Add Friend</span>
  </v-card-title> -->

  <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">person_add</v-icon>&nbsp;&nbsp;เพิ่มข้อความตอบอัตโนมัติ</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>

  <v-card-text >
      <v-container grid-list-md>
        <v-layout wrap>
          <!-- --------------search------------- -->
          <v-flex xs12 md12 style=""> <span>ข้อความรับเข้า :</span></v-flex>
            <v-flex xs12 md12 style="display: flex;justify-content: center;">
                <input type="text" placeholder="" class="InputEdit"  v-model="receive"> 
            </v-flex>
            <v-flex xs12 md12 style="margin-top: 1vh;"> <span>ข้อความตอบกลับ :</span></v-flex>
            <v-flex xs12 md12 style="display: flex;justify-content: center;">
                <textarea  placeholder=""  class="InputEdit" style="height:100px;"  v-model="reply"></textarea>
            </v-flex>
            <v-flex xs10 md10> </v-flex>
            <v-flex xs2 md2 style="display: flex;justify-content: center;">
              <v-btn color="blue darken-1" flat @click="set_reply" class="CSChatThai">บันทึก</v-btn> 
            </v-flex>
            
            
        </v-layout>
    </v-container>
</v-card-text>


</v-card>
</v-dialog>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {'dialogAdd': false},
  data: () => ({
    reply: '',
    receive: '',
    token: ''
  }),
  computed: {
    ...mapState({
      botinfo: 'botinfo'
    })
  },
  methods: {
    closeDialog () {
      // ga('send','event','Add Friend Conversion','Click Navbar','Cancel')
      this.$emit('closeFriend', false)
      this.receive = ''
      this.reply = ''
    },
    set_reply () {
      this.$http.post(process.env.APImanage + '/addreplybot', {token_bot: this.token, receive_message: this.receive, reply_message: this.reply}).then((response) => {
        if (response.body['status'] === 'success') {
          // console.log(response.body)
          this.$swal(
            'เพิ่มข้อความตอบกลับ',
            'เพิ่มข้อความตอบกลับสำเร็จ.',
            'success'
          )
          this.closeDialog()
          this.$store.dispatch('changeReply', 'addreplybot' + this.token + this.receive + this.reply)
        }
      }, (response) => {})
    }
  },
  created () {
    this.token = this.botinfo.tokenuser
  }
}
</script>
<style type="text/css" scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.alligator-turtle {
  
  object-fit: cover;
  object-position: 50% 0;
} 
.application .theme--light.input-group input, .application .theme--light.input-group textarea, .theme--light .input-group input, .theme--light .input-group textarea {
    /* color: rgba(0,0,0,.87); */
    color: #53ceff !important;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.InputEdit {
    width: 100%;
    padding: 10px 15px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/AddreplyDialogMo.vue